<template>
  <index_layout :searchable="false"> <elink /></index_layout>
</template>

<script>
import index_layout from "../_layout/index_layout";
import ELink from "./ELink";
export default {
  components: {
    index_layout: index_layout,
    elink: ELink,
  },
};
</script>

<style>
</style>